// extracted by mini-css-extract-plugin
export var activeDot = "communitySuccessStories-module--active-dot--12888";
export var attribution = "communitySuccessStories-module--attribution--ce798";
export var buttons = "communitySuccessStories-module--buttons--2ee98";
export var card = "communitySuccessStories-module--card--b228f";
export var cardBody = "communitySuccessStories-module--card-body--62b1e";
export var cardImage = "communitySuccessStories-module--card-image--ac8a0";
export var carousel = "communitySuccessStories-module--carousel--fa10f";
export var communitySuccessStories = "communitySuccessStories-module--community-success-stories--0aaba";
export var ctaHeadline = "communitySuccessStories-module--cta-headline--ca1ca";
export var ctaSection = "communitySuccessStories-module--cta-section--26db6";
export var dot = "communitySuccessStories-module--dot--55c1e";
export var dots = "communitySuccessStories-module--dots--93cbf";
export var grid = "communitySuccessStories-module--grid--1f158";
export var headline = "communitySuccessStories-module--headline--6c70a";
export var inner = "communitySuccessStories-module--inner--48eac";
export var name = "communitySuccessStories-module--name--88e8e";
export var primaryButton = "communitySuccessStories-module--primary-button--a05c0";
export var quote = "communitySuccessStories-module--quote--caf3b";
export var quoteIcon = "communitySuccessStories-module--quote-icon--755fb";
export var secondaryButton = "communitySuccessStories-module--secondary-button--3092d";
export var subtitle = "communitySuccessStories-module--subtitle--057c6";